import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/shared/ui/button";
import type { AttributeWithCounts } from "./attributeUtils";

interface AttributesTableRowProps {
  attribute: AttributeWithCounts;
  onEdit: (attribute: AttributeWithCounts) => void;
  onDelete: (attribute: AttributeWithCounts) => void;
  onViewCategories: (attribute: AttributeWithCounts) => void;
  onViewValues: (attribute: AttributeWithCounts) => void;
}

export function AttributesTableRow({
  attribute,
  onEdit,
  onDelete,
  onViewCategories,
  onViewValues,
}: AttributesTableRowProps) {
  return (
    <tr className="hover:bg-grid-50 transition-colors">
      <td className="px-6 py-4">
        <div className="font-medium text-ink-900">{attribute.name}</div>
      </td>
      <td className="px-6 py-4">
        <button
          onClick={() => onViewCategories(attribute)}
          className="inline-flex items-center rounded-md bg-grid-100 px-2.5 py-0.5 text-sm font-medium text-ink-700 hover:bg-grid-200 hover:text-ink-900 transition-colors"
        >
          {attribute.categoriesLinked}{" "}
          {attribute.categoriesLinked !== 1 ? "categories" : "category"} linked
        </button>
      </td>
      <td className="px-6 py-4">
        <button
          onClick={() => onViewValues(attribute)}
          className="inline-flex items-center rounded-md bg-grid-100 px-2.5 py-0.5 text-sm font-medium text-ink-700 hover:bg-grid-200 hover:text-ink-900 transition-colors"
        >
          {attribute.valuesLinked} value
          {attribute.valuesLinked !== 1 ? "s" : ""} attached
        </button>
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center justify-end gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(attribute)}
            className="h-8 w-8"
          >
            <Pencil className="h-4 w-4" />
            <span className="sr-only">Edit</span>
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(attribute)}
            className="h-8 w-8 text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            <Trash2 className="h-4 w-4" />
            <span className="sr-only">Delete</span>
          </Button>
        </div>
      </td>
    </tr>
  );
}
